import { ItemType, NavLinkItem } from '../../../../models/Navigation';

export const dataToolsDropdownOptions = (userPermissions: string[] | undefined): NavLinkItem[] => {
  const options: NavLinkItem[] = [
    {
      type: ItemType.NAVLINK,
      text: 'Bond Compare',
      to: '/data-tools/bond-compare',
    },
    {
      type: ItemType.NAVLINK,
      text: 'Loan Compare',
      to: '/data-tools/loan-compare',
    },
  ];

  if (userPermissions?.includes('ui:covenants:data_tools:bonds_search')) {
    options.push({
      type: ItemType.NAVLINK,
      text: 'Bond Precedent Search',
      to: '/data-tools/bond-search',
    });
  }

  if (userPermissions?.includes('ui:covenants:data_tools:loans_search')) {
    options.push({
      type: ItemType.NAVLINK,
      text: 'Loan Precedent Search',
      to: '/data-tools/loan-search',
    });
  }

  options.push({
    type: ItemType.NAVLINK,
    text: 'Documentation Score',
    to: '/data-tools/doc-score/us',
  });

  return options;
};
